import z from 'zod';

export const pp_onlineEntryZodObject = {
  onlineEntry: z.object({
    onlineEntriesId: z.number().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    birthdate: z.date().optional(),
    emailAddress: z.string().optional(),
    agentEmailAddress: z.string().optional(),
    addressHouseName: z.string().optional(),
    addressFirstLine: z.string().optional(),
    addressSecondLine: z.string().optional(),
    addressTown: z.string().optional(),
    addressCounty: z.string().optional(),
    addressCountry: z.number().optional(),
    addressCountryObject: z
      .object({
        id: z.string().optional(),
        name: z.string().optional(),
        numericIso: z.string().optional(),
        countryId: z.string().optional(),
      })
      .optional(),
    addressPostCode: z.string().optional(),
    phoneNumber: z.string().optional(),
    phoneCountryCode: z.string().optional(),
    mobilePhoneNumber: z.string().optional(),
    mobilePhoneCountryCode: z.string().optional(),
    nationality: z.number().optional(),
    nationalityObject: z
      .object({
        id: z.string().optional(),
        name: z.string().optional(),
        numericIso: z.string().optional(),
        countryId: z.string().optional(),
      })
      .optional(),
    handicapCategory: z.string().optional(),
    handicapCertificate: z.any().optional(),
    regionalQualifyingVenue1: z.number().optional(),
    regionalQualifyingVenue2: z.number().optional(),
    preferredLengthUnit: z.string().optional().nullable(),
    finalQualifyingPref1: z.number().optional(),
    finalQualifyingPref2: z.number().optional(),
    finalQualifyingPref3: z.number().optional(),
    finalQualifyingPref4: z.number().optional(),
    pgaTour: z.array(z.string().optional()).optional(),
    golfClub: z.string().optional(),
    isExempt: z.number().optional(),
    dateAdded: z.string().optional(),
    amPro: z.string().optional(),
    caddieName: z.string().optional(),
    caddieEmail: z.string().optional(),
    requiredLocalCaddy: z.boolean().optional(),
    cdhNumber: z.string().optional(),
    entryFeeAmount: z.number().optional(),
    isEntryFeePaid: z.boolean().optional(),
    privacyPolicyAccepted: z.boolean().optional(),
    privacyPolicyAcceptedUnder18: z.boolean().optional(),
    acceptedTermsAndConditions: z.boolean().optional(),
    acceptedTermsUnder18: z.boolean().optional(),
    exemptionCategories: z.array(z.string().optional()).optional(),
    exemptionCategoriesFQ: z.array(z.string().optional()).optional(),
    championshipId: z.number().optional(),
    isoCountryCode: z.number().optional(),
    externalID: z.string().optional(),
    externalSystem: z.string().optional().nullable(),
    externalSystemOther: z.string().optional().nullable(),
    productId: z.string().optional(),
    handicapEmailRecipient: z.string().optional(),
    parentName: z.string().optional(),
    parentEmail: z.string().optional(),
    parentPhone: z.string().optional(),
    parentPhoneCountryCode: z.string().optional(),
    parentRelationship: z.string().optional(),
  }),
  handicapCategory: z.string().optional(),
  handicapDecimals: z.string().optional(),
  referrer: z.string().optional(),
};
